/**
 * Idempotency keys for order creation (Playbook 12 — Order Placement Contract, §B4).
 *
 * The backend dedupes order-create on (client_id, idempotencyKey): a retry —
 * double-click, flaky network, user pressing Pay again after an error — with
 * the SAME key returns the already-created order instead of creating a second.
 *
 * Usage: mint ONE key per checkout attempt (per screen mount via useRef) and
 * send it on every createOrder retry of that same logical order. A new visit
 * to the screen mints a new key.
 */
export function newIdempotencyKey() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  // Fallback for older browsers: time + randomness (collision-safe enough for
  // a per-user dedupe window).
  return `idk-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

export default newIdempotencyKey;
